// PartnerSpot — labelled sponsored placements (rail + in-feed).
import React from "react";
import GoogleAd from "./GoogleAd";
import { useLang } from "./i18n";
import { WhyAdsLink } from "./KeepFree";

// Two placements only, both clearly labelled and with reserved space so the
// page never jumps when an ad fills:
//   rail   — desktop right column, sticky: always visible, never over content.
//   infeed — a full-width row between product rows, styled like the cards.
export default function PartnerSpot({ variant }: { variant: "rail" | "infeed" }) {
    const { t } = useLang();

    if (variant === "rail") {
        return (
            <aside className="hidden lg:block w-[300px] shrink-0 py-6 pr-6" aria-label={t.sponsored}>
                <div className="sticky top-44 rounded-2xl border border-gray-100 bg-white/70 p-3 shadow-sm">
                    <p className="mb-2 flex items-center justify-between text-[10px] font-semibold uppercase tracking-widest text-gray-400">
                        {t.sponsored}
                        <WhyAdsLink className="normal-case tracking-normal" />
                    </p>
                    <div className="min-h-[250px]">
                        <GoogleAd />
                    </div>
                </div>
            </aside>
        );
    }

    return (
        <div className="col-span-full rounded-2xl border border-dashed border-gray-200 bg-gray-50/60 p-3" aria-label={t.sponsored}>
            <p className="mb-2 flex items-center justify-between text-[10px] font-semibold uppercase tracking-widest text-gray-400">
                {t.sponsored}
                <WhyAdsLink className="normal-case tracking-normal" />
            </p>
            <div className="min-h-[120px]">
                <GoogleAd />
            </div>
        </div>
    );
}
